












































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import {GrupaVozila, PodgrupaVozila} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service';
import mixin from "vue-i18n/src/mixin";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

declare const $: any;

@Component({})
export default class GrupeVozila extends mixins(ComponentBaseMixin) {
    grupa = new GrupaVozila();
    podgrupa = new PodgrupaVozila();
    columns = [];
    options = {
        pagination: true,
        search: true,
        detailView: true,
        detailFormatter: this.renderDetails,
        onClickRow: (grupa) => this.edit(grupa)
    };
    dataSource = [];
    dialogVisible = false;
    selectedDetailsTableClass = '';

    async created() {
        this.columns = [
            {field: 'naziv', title: this.$i18n.t('naziv')}
        ];
        this.dataSource = await this.loadData<GrupaVozila[]>(dataProxy.vratiGrupeVozila.bind(dataProxy))();
    }

    fokusirajNazivPodgrupe() {
        (<HTMLElement>this.$refs.nazivPodgrupe).focus();
    }

    novaGrupa() {
        this.grupa = new GrupaVozila();
        (<HTMLElement>this.$refs.naziv).focus();
    }

    private edit(grupa) {
        this.grupa = grupa;
    }

    private renderDetails(ix, grupa: GrupaVozila, element) {
        const detailsTableId = `detailsTable_${ix}`;
        const $detailsTable = $(`<table class='${detailsTableId}'></table>`).bootstrapTable({
            columns: [
                {field: 'naziv', title: this.$i18n.t('podgrupaVozila')},
                {
                    field: 'id', width: 30, formatter:
                        (id) => `<button class="btn btn-icon waves-effect waves-light btn-sm btn-light btn-delete-subgroup" data-id="${id}" data-table="${detailsTableId}"><i class="dripicons-trash"></i></button>`,
                    title: `<button class="btn btn-icon waves-effect waves-light btn-light btn-sm btn-add-subgroup" data-table="detailsTable_${ix}"><i class="fa fa-plus"></i></button>`
                }
            ],
            data: grupa.podgrupeVozila,
            onPostBody: () => {
                this.$nextTick(() => {
                    $(`.${detailsTableId} .btn-delete-subgroup`).on('click', (e) => {
                        const id = $(e.currentTarget).data('id');
                        const tableClass = $(e.currentTarget).data('table');
                        this.obrisiPodgrupu(id, tableClass);
                    });
                    $(`.${detailsTableId} .btn-add-subgroup`).on('click', (e) => {
                        this.podgrupa = PodgrupaVozila.fromJS({idGrupe: grupa.id});
                        this.selectedDetailsTableClass = $(e.currentTarget).data('table');
                        this.dialogVisible = true;
                    });
                });
            }
        });
        $detailsTable.appendTo(element);
    }

    async sacuvajGrupu() {
        const isValid = await (<any>this.$refs.formSaveGroup).validate();
        if (isValid) {
            this.grupa.id = await this.saveData(() => dataProxy.sacuvajGrupuVozila(this.grupa))();
            this.dataSource = await this.loadData(() => dataProxy.vratiGrupeVozila())();
        }
    }

    async obrisiGrupu() {
        const da = await this.confirmationNeeded('da li zelite da obrisete grupu');
        if (da) {
            this.dataSource = await this.deleteData(() => dataProxy.obrisiGrupuVozila(this.grupa.id))();
            this.novaGrupa();
        }
    }

    async dodajPodgrupu() {
        const isValid = await (<any>this.$refs.observer).validate();
        if (isValid) {
            this.dialogVisible = false;
            const podgrupe = await this.saveData(dataProxy.sacuvajPodgrupuVozila.bind(dataProxy, this.podgrupa))();
            const table = $("." + this.selectedDetailsTableClass);
            table.bootstrapTable('load', podgrupe);
        }
    }

    private async obrisiPodgrupu(id, tableClass) {
        const yes = await this.confirmationNeeded('da li zelite da obrisete podgrupu?');
        if (yes) {
            const podgrupe = await this.deleteData(() => dataProxy.obrisiPodgrupuVozila(id))();
            const table = $('.' + tableClass);
            table.bootstrapTable('load', podgrupe);
        }
    }


}
